module.exports = __webpack_public_path__ + "media/ck_pano.37eb0dad.mp4";